<template>
<div class="user_order no-trans" v-loading="loading">
    <div class="order_titles">我的点评</div>
    <div class="user_order_box">
        <div class="order_types">
            <div class="lefts">
                <div class="types" :class="{types_ac:types_ac==item.state}" v-for="(item,index) in type_list" :key="index" @click="handle_type(item)">
                    {{ item.title }}
                </div>
            </div>
            <div class="rights">
                <el-input
                    placeholder="输入商品名称、订单号"
                    v-model="keywords">
                    <div slot="suffix" class="" @click="handle_seach">
                        <img src="../../../../assets/img/user_info/user_order/seach.png" alt="">
                    </div>
                </el-input>
            </div>
        </div>
        <div class="order_0" v-if="order_list.length==0">
            <img src="@/assets/img/user_info/user_grzx/order_0.png" alt="">
            <div class="texts">暂无待处理订单</div>
        </div>
        <div class="order_list" v-if="order_list.length!=0">
            <div class="order_item" v-for="(item,index) in order_list " :key="index">
                <div class="item_titles">
                    <div class="order_lefts">
                        <div class="order_time">{{ item.case.created_at }}</div>
                        <div class="order_no">订单号：{{ item.case.order_sn }}</div>
                        <div class="order_expire_date">
                            <span v-if="item.is_expire_date">倒计时：</span>
                            <el-statistic v-if="item.is_expire_date" format="DD天HH小时mm分钟" :value="item.expire_date" time-indices ></el-statistic>
                            <span v-if="!item.is_expire_date">已超时</span>
                        </div>
                    </div>
                    <div class="order_rights">
                        
                        {{ item.status==10?'待点评':'' }}
                        {{ item.status==11?'待审核':'' }}
                        {{ item.status==20?'已点评':'' }}
                        {{ item.status==30?'被取消':'' }}
                    </div>
                </div>
                <div class="order_info">
                    <div class="shop_list">
                        <div class="shop_item">
                            <div class="shop_left">
                                <div class="shop_img">
                                    <img src="@/assets/img/index/comments_case/grade_c.png" alt="" v-if="item.grade==1">
                                    <img src="@/assets/img/index/comments_case/grade_z.png" alt="" v-if="item.grade==2">
                                    <img src="@/assets/img/index/comments_case/grade_g.png" alt="" v-if="item.grade==3">
                                    <img src="@/assets/img/index/comments_case/grade_t.png" alt="" v-if="item.grade==4">
                                </div>
                                <div class="shop_title">{{ item.case.title }}</div>
                            </div>
                            <div class="shop_right">
                                <div class="shop_price1">{{item.case.pay_money}}元</div>
                              
                            </div>
                        </div>
                    </div>
                    <div class="order_btns">
                        <div class="btns_lefts">
                            <div class="text1">
                                <img src="@/assets/img/index/comments_case/user_img.png" alt="" v-if="!item.user.image">
                                 <img :src="item.user.image" alt="" v-if="item.user.image">
                                {{ item.user.nickname||'用户昵称' }}
                            </div>
                            <div class="text2">
                                合计金额
                                <span> {{item.case.pay_money}}</span>
                                元 
                            </div>
                        </div>
                        <div class="btns_right">
                            <div class="btns1" @click="handle_detial(item)">订单详情</div>
                            <div class="btns2" @click="handle_add(item)" v-if="item.status==10">立即点评</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pages_box">
            <div class="btns" @click="handle_pages(1)">首页</div>
            <site-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.page"
                background
                :page-size="pages.limit"
                layout="prev, pager, next"
                :total="total">
            </site-pagination>
            <div class="btns"  @click="handle_pages(last_page)">尾页</div>
        </div>
    </div>
    
</div>
</template>
<script>
import { mapState} from 'vuex'
 
 

export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            keywords:'',//
            types_ac:0,
            type_list:[
                {
                    title:'全部点评',
                    state:0,
                },
                {
                    title:'待点评',
                    state:10,
                },
                {
                    title:'待审核',
                    state:11,
                },
                {
                    title:'已点评',
                    state:20,
                },
                {
                    title:'被取消',
                    state:30,
                }
                
            ],
            order_list:[],

            total:100,
            pages:{
                page:1,
                limit:10,
            },
            last_page:1,
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_type(item){
            this.types_ac=item.state
            this.pages.page=1
            this.get_list()
        },
        handle_seach(){
            console.log('点击搜索')
        },
        handleSizeChange(e){
            console.log('条数',e)            
            this.pages.limit=e
            this.get_list()
        },
        handleCurrentChange(e){
            console.log('页数',e)
            this.pages.page=e
            this.get_list()

        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()

        },
        handle_detial(item){
            this.$router.push({
                path:'/user_dpfw/user_dpfw_detial',
                query:{
                    id:item.case.id,
                }
            })
        },
        handle_add(item){
            this.$router.push({
                path:'/user_dpfw/user_dpfw_add',
                query:{
                    id:item.case.id,
                    grade:item.comment_level,
                }
            })
        },
        get_list(){
            this.loading=true
            this.$api("lawyerCaseCommentList", {
                status:this.types_ac,
                ...this.pages,
                keywords:this.keywords,
			}, "get").then((res) => {
                this.loading = false
                this.loading=false
                console.log('我的点评列表',res)
                if (res.code == 1) {
                    this.order_list=res.data.data
                    this.order_list.forEach((e)=>{
                        e.expire_date= Date.parse(e.expire_date)
                        e.is_expire_date=e.expire_date>Date.now()
                    })
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },



    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box{
        padding: 24px 32px;    
        margin-top: 24px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .order_types{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .lefts{
                display: flex;
                align-items: center;
                .types{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    padding-bottom: 12px;
                    margin-right: 48px;
                    border-bottom: 4px solid #FFFFFF;
                    cursor: pointer;
                    &:hover{
                        border-bottom: 4px solid #377CFD;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                    }
                }
                .types_ac{
                    border-bottom: 4px solid #377CFD;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
            .rights{
                /deep/.el-input{
                    width: 282px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    // border: 1px solid #B8C4D1;
                    .el-input__inner{
                        width: 282px;
                        height: 32px;
                    }
                    .el-input__suffix{
                        display: flex;
                        // line-height: 32px;
                        margin-right: 3px;
                        align-items: center;
                        cursor: pointer;
                        img{
                            width: 18px;
                        }
                    }
                }
            }
        }
        .order_0{
            text-align: center;
            padding-top: 65px;
            img{
               width: 190px; 
            }
            .texts{
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }
        .order_list{
            padding: 32px 0;
            .order_item{
                width: 1132px;
                // min-height: 200px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                margin-bottom: 22px;
                .item_titles{
                    width: 1132px;
                    height: 44px;
                    background: #F5F5F5;
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #E5E5E5;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding:0 24px ;
                    .order_lefts{
                        display: flex;
                        align-items: center;
                        .order_time{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                            margin-right: 20px;
                        }
                        .order_no{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                        }
                        .order_expire_date{
                            display: flex;
                            align-items: center;
                            margin-left: 20px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                            span{
                                flex-shrink: 0;
                            }
                            /deep/.number{
                                font-size: 14px;
                            }

                        }
                    }
                    .order_rights{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;

                    }
                }
                .order_info{
                    padding:0 24px;
                    padding-top: 24px;
                    .shop_list{
                        
                        border-bottom: 1px solid #E5E5E5;
                        .shop_item{
                            margin-bottom: 24px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .shop_left{
                                display: flex;
                                align-items: center;
                                .shop_img{
                                    width: 70px;
                                    // height: 104px;
                                    img{
                                        width: 70px;
                                        // height: 104px;
                                    }
                                }
                                .shop_title{
                                    padding-left: 24px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 16px;
                                    color: #333333;

                                }
                            }
                            .shop_right{
                                display: flex;
                                align-items: center;
                                .shop_price1{
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;

                                }
                                
                            }
                        }
                    }
                    .order_btns{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 64px;
                        .btns_lefts{
                            display: flex;
                            align-items: center;
                            .text1{
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                img{
                                    width:40px ;
                                    height: 40px;
                                    margin-right: 16px;
                                }
                                
                            }
                            .text2{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                margin-left: 20px;
                                span{
                                    color: #377CFD;
                                    font-weight: bold;

                                }
                            }
                        }
                        .btns_right{
                            display: flex;
                            align-items: center;
                            .btns1{
                                width: 104px;
                                height: 32px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                line-height: 32px;
                                text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                                cursor: pointer;
                            }   
                            .btns2{
                                width: 104px;
                                height: 32px;
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px;
                                text-align: center;
                                line-height: 32px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFFFFF;
                                cursor: pointer;
                                margin-left: 10px;
                            }

                        }
                    }
                    

                }
            }
        }
        .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: end;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  
                        
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;  

                        }
                        .active{
                            background-color: #377CFD;
                        }
                        .el-icon{
                            background-color: #FFFFFF;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  

                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
    }


}
</style>
<style scoped lang="less">
@import "../../../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .user_order.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_order.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .user_order.no-trans .user_order_box {
        padding: 16px 16px;
        margin-top: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .user_order.no-trans .user_order_box .order_types {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types {
        font-size: 14px;
        padding-bottom: 12px;
        margin-right: 16px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types_ac {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__inner {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__suffix {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-right: 3px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__suffix img {
        width: 18px;
    }
    .user_order.no-trans .user_order_box .order_0 {
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .order_0 img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_0 .texts {
        padding-top: 16px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list {
        padding: 16px 0;
    }
    .user_order.no-trans .user_order_box .order_list .order_item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 0px 0px 0px 0px;
        margin-bottom: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 16px;
        min-height: 44px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles .order_lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles .order_lefts .order_time {
        font-size: 14px;
        margin-right: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles .order_lefts .order_no {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles .order_lefts .order_expire_date {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-left: 16px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles .order_lefts .order_expire_date /deep/ .number {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .item_titles .order_rights {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info {
        padding: 0 16px;
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item {
        margin-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_left {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_left .shop_img {
        width: 70px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_left .shop_img img {
        width: 70px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_left .shop_title {
        padding-left: 16px;
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_right {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .shop_list .shop_item .shop_right .shop_price1 {
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        height: auto;
        min-height: 44px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_lefts .text1 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_lefts .text1 img {
        width: 40px;
        height: 40px;
        margin-right: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_lefts .text2 {
        font-size: 14px;
        margin-left: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_right {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_right .btns1 {
        width: 104px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_order.no-trans .user_order_box .order_list .order_item .order_info .order_btns .btns_right .btns2 {
        width: 104px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        margin-left: 10px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_order.no-trans .user_order_box .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}

@media (max-width: 1024px) {
    .user_order.no-trans { .mobile-order-list(); }
}
</style>
